import {
  GET_INVOICES,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_ERROR,

} from "./actionTypes"

/**
 * 
 * @param {Object} payload Object with { use_bill_com }
 * 
 */
export const getInvoices = (payload) => ({
  type: GET_INVOICES,
  payload: payload
})

export const getInvoicesSuccess = (Receipt) => ({
  type: GET_INVOICES_SUCCESS,
  payload: Receipt
})

export const getInvoicesError = (error) => ({
  type: GET_INVOICES_ERROR,
  payload: error
})
